import { Grid, useTheme } from "@mui/material";
import React, { FunctionComponent } from "react";
import { sxClsx } from "utils/styleClsx";
import { ChevronLeftRounded, ChevronRightRounded } from "@mui/icons-material";

interface OwnProps {
    drawerOpen: boolean;
    left?: number;

    onClick?: () => void;
    style?: React.CSSProperties;
}

type Props = OwnProps;

const DrawerToggleButton: FunctionComponent<React.PropsWithChildren<Props>> = (
    props,
) => {
    const theme = useTheme();
    return (
        <>
            {props.left !== undefined && (
                <Grid
                    onClick={props.onClick}
                    sx={sxClsx(
                        {
                            display: "none",
                            pointerEvents: "auto",
                            position: "absolute",
                            top: "47%",
                            transform: "translateY(-50%)",
                            backgroundColor: theme.palette.white.main,
                            paddingY: "8px",
                            width: "auto",
                            height: "auto",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: theme.zIndex.drawer + 1,
                            cursor: "pointer",
                            "&:hover": {
                                opacity: 0.5,
                            },
                        },
                        !props.drawerOpen && {
                            display: "flex",

                            left: 0,
                            boxShadow:
                                "0 10px 15px 0 rgba(0, 0, 0, 0.10), 0 4px 6px 0 rgba(0, 0, 0, 0.05)",
                            borderRadius: "0px 2px 2px 0px",
                        },
                        props.drawerOpen && {
                            display: "flex",

                            left: props.left,
                            borderRadius: "2px",
                        },
                    )}
                >
                    {props.drawerOpen ? (
                        <ChevronLeftRounded
                            sx={{ height: "20px", width: "20px" }}
                        />
                    ) : (
                        <ChevronRightRounded
                            sx={{ height: "20px", width: "20px" }}
                        />
                    )}
                </Grid>
            )}
        </>
    );
};

export default DrawerToggleButton;
